import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container'
import { useNavigate, useLocation } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, post, postFormData } from '../../ApiServices/ApiServices';

// second component 
function AddBrideDetail({ onSubmit, onNext, onBack, initialValues }) {
    const { register, handleSubmit, formState: { errors }, getValues } = useForm({
        defaultValues: initialValues
    });
    const location = useLocation()

    const navigate = useNavigate();
    // BrideName: formData.BrideName,
    // SameAddress: formData.SameAddress,
    // Address: formData.Address,
    // State: formData.State,
    // City: formData.City,
    // ZipCode: formData.ZipCode,
    // PhoneNumber: formData.PhoneNumber,
    // EmailAddress: formData.EmailAddress,

    const handleBack = () => {
        // Save current form values before going back
        const currentValues = getValues();
        onBack(currentValues);
    };


    const [getState, setGetState] = useState([])

    const ViewState = async () => {
        try {
            const api = `get-states`;
            const response = await get(api);
            if (response?.message == "success") {
                setGetState(response.data);
            }
        } catch (err) {

            console.error('Errordsfdsfd:', err);
        } finally {
            console.log("first")
        }
    };
    useEffect(() => {
        ViewState();

    }, [initialValues]);

    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Weddings Events</h3></div>
                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section class="section1">
                                                    <header>
                                                        <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div> Add Groom Detail
                                                    </header>
                                                </section>
                                                <section class="section2">
                                                    <header>
                                                        <div class="bead current"><span>2</span></div>Add Fiancée Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div class="bead"><span>3</span></div> Add Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div class="bead"><span>4</span></div> Add Description
                                                    </header>
                                                </section>
                                            </div>


                                            <div className="col-md-8">
                                                <h4>Bride Detail</h4>
                                                <form onSubmit={handleSubmit(onNext)}>

                                                    <div className="inputCardBox mt-4">
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label>Fiancée's Name  <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter name" {...register("BrideName", { required: "Fiancée's name is required" })} />
                                                                {errors.BrideName && <p className='text-red-500'>{errors.BrideName.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Same Address  <span className="text-red-500">*</span></label>
                                                                <select {...register("SameAddress", { required: "This field is required" })} >
                                                                    <option value="">Select</option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>

                                                                </select>
                                                                {errors.SameAddress && <p className='text-red-500'>{errors.SameAddress.message}</p>}
                                                                <p><small>Is Fiancée's address the same as Groom's?</small></p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Address  <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter address" {...register("BrideAddress", { required: "Fiancée's address is required" })} />
                                                                {errors.BrideAddress && <p className='text-red-500'>{errors.BrideAddress.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>State  <span className="text-red-500">*</span></label>
                                                                <select {...register("BrideState", { required: "State is required" })}>
                                                                    <option value="">Select state</option>
                                                                    {getState.length > 0 && getState.map((items, index) => {
                                                                        return (
                                                                            <>
                                                                                <option key={index} value={items.name}>{items.name}</option>
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                {errors.BrideState && <p className='text-red-500'>{errors.BrideState.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>City  <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter city" {...register("BrideCity", { required: "City is required" })} />
                                                                {errors.BrideCity && <p className='text-red-500'>{errors.BrideCity.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Zip Code <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter zipcode" {...register("BrideZipCode", { required: "Zip code is required" })} />
                                                                {errors.BrideZipCode && <p className='text-red-500'>{errors.BrideZipCode.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Phone Number <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter phone number" {...register("BridePhoneNumber", { required: "Phone number is required" })} />
                                                                {errors.BridePhoneNumber && <p className='text-red-500'>{errors.BridePhoneNumber.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Email Address <span className="text-red-500">*</span></label>
                                                                <input className="" type="text" placeholder="Enter E-mail" {...register("BrideEmailAddress", { required: "Email address is required" })} />
                                                                {errors.BrideEmailAddress && <p className='text-red-500'>{errors.BrideEmailAddress.message}</p>}
                                                            </div>

                                                            <div className="col-md-12 mt-3">
                                                                <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                <button type="submit" className="addBtnCustomer">Continue</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default AddBrideDetail